import { apiService } from './api';
import {
  DamageNoteDTO,
  DamageNoteListDTO,
  DamageNoteApprovalStatusDTO,
  DamageNoteStatsDTO,
  CreateDamageNoteRequest,
} from '../types';

const API = '/damage-notes';

export const damageNoteService = {
  // ── CRUD ──────────────────────────────────────────────────────────────────

  getAll: (pageNumber = 1, pageSize = 50) =>
    apiService.get<{ data: DamageNoteListDTO[]; pagination: { total: number; page: number; pageSize: number } }>(
      API, { pageNumber, pageSize }
    ),

  getById: (id: number | string) =>
    apiService.get<DamageNoteDTO>(`${API}/${id}`),

  getStats: () =>
    apiService.get<DamageNoteStatsDTO>(`${API}/stats`),

  create: (data: CreateDamageNoteRequest) =>
    apiService.post<DamageNoteDTO>(API, data),

  update: (id: number | string, data: Partial<CreateDamageNoteRequest> & { items: CreateDamageNoteRequest['items'] }) =>
    apiService.put<DamageNoteDTO>(`${API}/${id}`, data),

  delete: (id: number | string) =>
    apiService.delete<boolean>(`${API}/${id}`),

  // ── Workflow ──────────────────────────────────────────────────────────────

  submit: (id: number | string, submittedByUserId: number) =>
    apiService.post<DamageNoteApprovalStatusDTO>(`${API}/${id}/submit`, { submittedByUserId }),

  getApprovalStatus: (id: number | string) =>
    apiService.get<DamageNoteApprovalStatusDTO>(`${API}/${id}/approvals`),

  approve: (approvalId: number, userId: number, comments?: string) =>
    apiService.post<DamageNoteApprovalStatusDTO>(
      `${API}/approvals/${approvalId}/approve`,
      { userId, comments }
    ),

  reject: (approvalId: number, userId: number, rejectionReason: string) =>
    apiService.post<DamageNoteApprovalStatusDTO>(
      `${API}/approvals/${approvalId}/reject`,
      { userId, rejectionReason }
    ),

  post: (id: number | string, postedByUserId: number) =>
    apiService.post<DamageNoteDTO>(`${API}/${id}/post`, { postedByUserId }),

  cancel: (id: number | string, cancelledByUserId: number, cancellationReason?: string) =>
    apiService.post<DamageNoteDTO>(`${API}/${id}/cancel`, { cancelledByUserId, cancellationReason }),
};
